import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your details.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#2E1B16] px-6 font-body" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <span className="w-9 h-9 rounded-xl bg-[#38BDF8] grid place-items-center"><Lock size={17} className="text-[#2E1B16]" /></span>
          <span className="font-display text-xl tracking-tight text-[#FAF7F2]">Lead Centre</span>
        </div>
        <form onSubmit={submit} className="bg-[#FAF7F2] rounded-3xl p-8 panel-shadow space-y-6" data-testid="admin-login-form">
          <div>
            <h1 className="font-display text-2xl tracking-tight text-[#2E1B16]">Staff sign in</h1>
            <p className="text-sm text-[#2E1B16]/55 mt-1">Authorised Viral Vision Media staff only.</p>
          </div>
          <label className="block">
            <span className="label-eyebrow text-[#2E1B16]/50 text-[0.65rem]">Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="mt-2 w-full bg-transparent border-b border-[#2E1B16]/20 py-3 text-[#2E1B16] focus:border-[#38BDF8] focus:outline-none transition-colors" placeholder="you@viralvisionmediaau.com" />
          </label>
          <label className="block">
            <span className="label-eyebrow text-[#2E1B16]/50 text-[0.65rem]">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="mt-2 w-full bg-transparent border-b border-[#2E1B16]/20 py-3 text-[#2E1B16] focus:border-[#38BDF8] focus:outline-none transition-colors" placeholder="••••••••" />
          </label>
          {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-full bg-[#2E1B16] text-[#FAF7F2] font-semibold py-3.5 hover:bg-[#38BDF8] hover:text-[#2E1B16] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
